<section class="content">
  <div class="container-fluid">
    <div class="row">

      <div class="row mt-3">
        <div class="d-flex justify-content-end">
          <div class="form-floating">
            <input type="search" class="form-control" placeholder="search" [(ngModel)]="searchText">
            <label class="text-gray">Search</label>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="table-style table-responsive table-bordered">
          <table class="table table-head-fixed text-nowrap text-center">
            <thead>
            <tr class="sticky-top">
              <th>S.No</th>
              <th>Customer Name</th>
              <th>Phone Number</th>
              <th>Product Name</th>
              <th>Enquiry Date</th>
              <!-- <th>Area</th>-->
              <th>City</th>
              <!-- <th>Pincode</th>
               <th>State</th>-->
              <th>Enquiry Status</th>
              <th>Order Confirmed?</th>
              <th>Proceed to Bill</th>
            </tr>
            </thead>
            <tbody class="text-center"
                   *ngIf="(enquiries | filter:searchText).length > 0; else noDataFound">
            <tr *ngFor="let item of this.enquiries | filter: searchText; let i = index">
              <td>{{ i + 1 }}</td>
              <td class="text-capitalize">{{ item.customerName || '-' }}</td>
              <td class="text-capitalize">{{ item.phoneNumber || '-' }}</td>
              <td class="text-capitalize text-wrap">{{ item.productDetails?.productName || '-'}}</td>
              <td class="text-capitalize">{{ item.createdAt | date: 'dd/MM/yyyy' || '-'}}</td>
              <!--<td class="text-capitalize">{{ item.doorNo || '-'}}, {{item.street || '-'}}</td>-->
              <td class="text-capitalize">{{ item.city || '-'}}</td>
              <!-- <td class="text-capitalize">{{ item.pincode || '-'}}</td>
               <td class="text-capitalize">{{ item.state || '-'}}</td>-->
              <td class="text-capitalize">
                <span
                  [ngClass]="{'badge-blue': item.enquiryStatus === 'OPEN', 'badge-red': item.enquiryStatus === 'CANCELED','badge-green': item.enquiryStatus === 'CONFIRMED'}"
                  class="badge">
                  {{ item.enquiryStatus || '-' }}
                </span>
              </td>
              <td>
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" [name]="'billType' + i" id="inlineRadio1{{i}}" value="CONFIRMED"
                         (change)="updateEnquiryStatus(item, i, 'CONFIRMED')" [checked]="item.enquiryStatus === 'CONFIRMED'">
                  <label class="form-check-label" for="inlineRadio1{{i}}">Yes</label>
                </div>
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" [name]="'billType' + i" id="inlineRadio2{{i}}" value="CANCELED"
                         (change)="updateEnquiryStatus(item, i, 'CANCELED')" [checked]="item.enquiryStatus === 'CANCELED'">
                  <label class="form-check-label" for="inlineRadio2{{i}}">No</label>
                </div>
                <!--<div class="form-floating">
                  <select class="form-select" id="floatingSelect" aria-label="Floating label select example" (change)="updateEnquiryStatus(item, $event)">
                    <option selected disabled value="">Enquiry Status</option>
                    <option value="CONFIRMED">Confirmed</option>
                    <option value="CANCELED">Canceled</option>
                  </select>
                  <label>Enquiry Status</label>
                </div>-->
                <!--<button class="btn-cancel" (click)="updateEnquiryStatus(item)"
                        [disabled]="item.enquiryStatus == 'CANCELED'">
                  Closed
                </button>-->
              </td>
              <td>
                <button class="btn-bill btn-block" (click)="invoiceDetails(item)" *ngIf="item.enquiryStatus == 'CONFIRMED'">Bill
                </button>
              </td>
              <!--<td>
                <div class="form-check">
                <input type="checkbox" class="form-check-input"
                       [checked]="item.isConvertedToOrder"
                       (change)="onCheckboxChange(item, $event)">
                </div>
              </td>-->
            </tr>
            </tbody>
            <ng-template #noDataFound>
              <tr class="text-center ubuntu-bold h6 text-danger">
                <td colspan="12">Data Not Found</td>
              </tr>
            </ng-template>
          </table>
        </div>
      </div>
    </div>
  </div>
</section>
